module.exports = __webpack_public_path__ + "d664201f/img/grid-web-icon.d0395d64.svg";